/**
 * Shared filename-extension helper for upload classifiers.
 */
export function extractFileExtension(fileName: string): string | null {
  if (!fileName) {
    return null;
  }
  const match = fileName.toLowerCase().match(/\.([a-z0-9]+)$/);
  return match ? match[1] : null;
}
